import React, { useEffect, useState } from 'react';
const names = ['María G.', 'Carlos R.', 'Laura M.', 'Diego S.', 'Valentina P.', 'Andrés L.', 'Camila F.', 'Martín H.', 'Sofía T.', 'Juan Pablo V.', 'Florencia D.', 'Sebastián A.', 'Luciana B.', 'Matías C.', 'Carolina E.', 'Federico N.', 'Paula K.', 'Nicolás J.', 'Agustina W.', 'Tomás Z.', 'Daniela O.', 'Alejandro Q.', 'Romina I.', 'Gonzalo U.', 'Micaela Y.'];
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 45) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    minutes: 0
  });
  useEffect(() => {
    function showPopup() {
      setData({
        name: getRandom(names),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }
    const initialTimeout = setTimeout(showPopup, 8000);
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className="fixed bottom-16 md:bottom-6 left-4 z-[60] max-w-[280px] transition-all duration-500 ease-out" style={{
    transform: visible ? 'translateX(0)' : 'translateX(-120%)',
    opacity: visible ? 1 : 0,
    pointerEvents: visible ? 'auto' : 'none'
  }} data-id="element-265">
      <div className="bg-white rounded-xl shadow-xl shadow-black/10 p-3 flex items-center gap-2.5 border border-gray-200" data-id="element-266">
        <div className="w-8 h-8 rounded-full bg-brand-green/10 flex items-center justify-center shrink-0 text-base" data-id="element-267">
          🛒
        </div>
        <div className="min-w-0" data-id="element-268">
          <p className="text-gray-900 text-sm font-semibold leading-tight" data-id="element-269">
            {data.name}
          </p>
          <p className="text-gray-500 text-[11px] leading-snug" data-id="element-270">
            Compró{' '}
            <span className="font-medium text-gray-700" data-id="element-271">Matemática 360</span> ·
            hace {data.minutes} min
          </p>
        </div>
      </div>
    </div>;
}